import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks";
import { IRegistrationPolicy } from "@pbm/registration-policies/contracts";
import { CursorPaginated } from "@types";

export function useRegistrationPolicies() {
  const { request } = usePbm2Url();
  return useQuery("registrationPolicies", async () => {
    const { Rules_registrationPolicies } = await request(
      gql`
        query registrationPolicies {
          Rules_registrationPolicies {
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
              pageCount
              totalCount
            }
            edges {
              cursor
              node {
                id
                description
                requiresRegistration
                requiresPrescription
                requiresContactInformation
                enabledApiExternal
                createdAt
                updatedAt
              }
            }
          }
        }
      `
    );
    return Rules_registrationPolicies as CursorPaginated<IRegistrationPolicy>;
  });
}
